<template>
  <header v-b-tooltip.window.top.hover="feederName" :disabled="pdfModalVisibility">
    <span>{{ feederNumber ? `Feeder ${feederNumber}` : 'TX' }}</span>
    <div v-if="feederNumber">
      <img
        v-if="diagrams.length"
        class="device-tile__pdf mt-0"
        src="~@/assets/images/pdf-small.png"
        alt="diagram-icon"
        @click="handleModalVisibility(true)"
      />
      <b-dropdown
        v-else
        class="dropdown--actions substation-agent__actions"
        variant="icon-only"
        no-caret
      >
        <template slot="button-content">
          <Icon name="contextual-menu" />
        </template>
        <b-dropdown-item :to="routerParams" class="dropdown--actions-item upload">
          Add diagram
        </b-dropdown-item>
      </b-dropdown>
      <FeederDiagramModal
        v-model="pdfModalVisibility"
        :diagrams="diagrams"
        :feeder-diagram-parent="selectedParent"
        :feeder-number="feederNumber"
        @hideModal="handleModalVisibility(false)"
      />
    </div>
  </header>
</template>

<script>
import FeederDiagramModal from '@/components/shared/fault-feeder-diagram-modal';
import { HIDE_TOOLTIP } from '@/components/shared/fault-consts';

export default {
  name: 'FaultPanelHeader',
  components: { FeederDiagramModal },
  props: {
    diagrams: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    },
    feederNumber: {
      type: Number,
      required: true
    },
    feederName: [String, Boolean],
    routerParams: {
      name: String,
      params: Object
    }
  },
  data() {
    return {
      pdfModalVisibility: false
    };
  },
  computed: {
    selectedParent() {
      const { externalGuardId } = this.$route.params;

      return externalGuardId ? 'Guard1000FaultPanel' : 'VisnetHubFaultEventsPanel';
    }
  },
  methods: {
    handleModalVisibility(value) {
      this.$root.$emit(HIDE_TOOLTIP);
      this.pdfModalVisibility = value;
    }
  }
};
</script>
